// frontend/src/modules/invoicing/components/ServicePicker.tsx
import * as React from 'react';
import { useApi } from '../../../design-system/useApi';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '../../../components/ui/select';
import type { Service } from '../types';

interface ServicePickerProps {
  value: string | null;
  onChange: (service: Service | null) => void;
}

export function ServicePicker({ value, onChange }: ServicePickerProps) {
  const { data, loading } = useApi<{ services: Service[] }>('/api/invoicing/services');
  const services = data?.services?.filter((s) => s.is_active) ?? [];

  function handle(id: string) {
    if (id === '__none__') { onChange(null); return; }
    const s = services.find((x) => x.id === id) ?? null;
    onChange(s);
  }

  return (
    <Select value={value ?? '__none__'} onValueChange={handle} disabled={loading}>
      <SelectTrigger><SelectValue placeholder="Service (optional)" /></SelectTrigger>
      <SelectContent>
        <SelectItem value="__none__">— None —</SelectItem>
        {services.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
